export default "__VITE_ASSET__BFXxfwYY__"